<template>
  <loader-wrapper :loading="loading" :showNoDataText="showNoDataText" :opacity="0.8">
    <div class="v-table-wrapper">
      <table-wrapper-header
        v-if="items.length > 0"
        :headers="headers"
        :is-fixed="fixedHeaders.length > 0"
        :fixed-headers="fixedHeaders"
        :multi-sort="multiSort"
      >

        <template
          v-for="(_, slotKey) of $scopedSlots"
          v-slot:[slotKey]="scope"
        >
          <slot :name="slotKey" v-bind="scope"></slot>
        </template>

      </table-wrapper-header>

      <table-wrapper-body
        v-if="items.length > 0"
        :headers="headers"
        :items="items"
        :is-fixed="fixedHeaders.length > 0"
        :fixed-headers="fixedHeaders"
      >

        <template
          v-for="(_, slotKey) of $scopedSlots"
          v-slot:[slotKey]="scope"
        >
          <slot :name="slotKey" v-bind="scope"></slot>
        </template>

      </table-wrapper-body>
    </div>
  </loader-wrapper>

</template>

<script>
  import TableWrapperHeader from './components/TableWrapperHeader'
  import TableWrapperBody from './components/TableWrapperBody'
  import { store } from './store'
  import LoaderWrapper from "@/components/common/LoaderWrapper";

  export default {
    name: 'index.vue',
    inheritAttrs: false,
    components: {TableWrapperBody, TableWrapperHeader, LoaderWrapper},
    props: {
      multiSort: {
        type: Boolean,
        default: false
      },
      headers: {
        type: Array
      },
      items: {
        type: Array
      },
      loading: {
        type: Boolean,
        default: false
      },
      showNoDataText: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      headerSlotKeys: [],
      bodySlotKeys: []
    }),
    computed: {
      fixedHeaders () {
        let fixedColumn = []
        for (let i = 0; i < this.headers.length; i++) {
          if (this.headers[i].isFixed) {
            fixedColumn.push({...this.headers[i]})
          } else {
            return fixedColumn
          }
        }
      },
    },
    methods: {
      setMain() {
        store.commit('setMainHeight', this.$el.offsetHeight)
        store.commit('setMainWidth', this.$el.offsetWidth)
      }
    },
    watch: {
      items: {
        handler() {
          this.$nextTick(() => {
            this.setMain()
          })
        }
      },
    },
    beforeCreate() {
      store.commit('clear')
    },
    mounted() {
      this.setMain()
      window.addEventListener('resize', this.setMain)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.setMain)
    }
  }
</script>

<style lang="scss">
  .v-table-wrapper {
    position: relative;
    width: 100%;
    min-height: 8vh;
    max-height: 50vh;
    overflow-x: hidden;
    overflow-y: hidden;

    .v-data-table__wrapper {
      overflow: visible !important;
    }

    table {
      border-left: 0;
      border-right: 0;
      border-spacing: 0;
      margin-bottom: 0;
      table-layout: fixed;
    }

    &-no-data {
      position: relative;
      width: 100%;
      border: 1px solid #e6e6e6;
      text-align: center;
    }

    &-no-data-text {
      margin: 50px 0;
    }
  }
</style>
